import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";

import { formatDate, formatMoney } from "../helpers";

function ClaimsSection({ claims, language, kind }) {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mt: 2, mb: 1 }}>
        {t("portfolioExplorer.claims.title")}
      </Typography>
      {claims.length === 0 ? (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t("portfolioExplorer.claims.none")}
        </Typography>
      ) : (
        claims.map((claim) => (
          <Box
            key={claim.id}
            sx={{ mb: 1.5, p: 1.25, border: "1px solid", borderColor: "divider", borderRadius: 1 }}
          >
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {claim.claim_number}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
              {kind === "property"
                ? t(`portfolioExplorer.enums.peril.${claim.peril}`)
                : t(`portfolioExplorer.enums.cause.${claim.cause}`)}
              {" · "}
              {t(`portfolioExplorer.enums.claimStatus.${claim.status}`)}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
              {t("portfolioExplorer.claims.lossDate")}: {formatDate(claim.loss_date, language)}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
              {t(`portfolioExplorer.enums.claimDescription.${claim.description}`)}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
              {t("portfolioExplorer.claims.claimed")}: {formatMoney(claim.claimed_amount, language)}
            </Typography>
            <Typography variant="caption" color="text.secondary" component="div">
              {t("portfolioExplorer.claims.paid")}: {formatMoney(claim.paid_amount, language)}
            </Typography>
            {kind === "motor" && (
              <Typography variant="caption" color="text.secondary" component="div">
                {t("portfolioExplorer.claims.accident")}: {claim.accident_address}
              </Typography>
            )}
          </Box>
        ))
      )}
    </Box>
  );
}

export default ClaimsSection;
